import React, { useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { useEffect } from "react";
import AOS from "aos";
import "./CounterSection.css";

const Counter = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const [state, setState] = useState(true);

  const counters = [
    {
      countNum: 51,
      countTitle: "Projects Delivered",
      counterPrefix: "+",
    },
    {
      countNum: 61,
      countTitle: "Client Served",
      counterPrefix: "+",
    },
    {
      countNum: 4,
      countTitle: "In House Products",
      counterPrefix: "+",
    },
    {
      countNum: 4,
      countTitle: "Countries Reached",
      counterPrefix: "+",
    },
    {
      countNum: 6,
      countTitle: "Security Audit",
      counterPrefix: "+",
    },
  ];

  return (
    <div className="rs-counter pb-100 md-pb-44">
      <div className="container">
        {counters && (
          <div className="row rs-counter couter-area counter-five">
            {counters.map((counter, num) => (
              <div
                key={num}
                className={`counter-col col-6 col-md-6 md-mb-30${
                  counter.countTitle === "Security Audit" ? " d-none d-sm-block" : ""
                }`}
              >
                <div className="counter-item text-center">
                  <h2 className="number rs-count secondary-color2">
                    <CountUp
                      start={state ? 0 : counter.countNum}
                      end={counter.countNum}
                      duration={5}
                      onEnd={() => setState(false)}
                    />
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                    <span className="counter-prefix">
                      {counter.counterPrefix}
                    </span>
                  </h2>
                  <h4 className="title mb-0">{counter.countTitle}</h4>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Counter;
